import { useSortable } from "@dnd-kit/sortable";
import { Box } from "@mui/material";
import { CSS } from "@dnd-kit/utilities";
import { Card } from "./card";
import IndicatorsCard from "./indicators-card";
import { IndexesCard } from "./indexes-card";
import { OtpByPortsCard } from "./otpByPorts-card";
import { ChartsCard } from "./charts-card";
import { DelaysCard } from "./delays-card";
import { CrewTATsCard } from "./crewtats-card";


const getCardSpan = (type) => {
  if (type === 'charts' || type === 'otpByPorts') return { xs: 'span 12', md: 'span 8' };
  if (type === 'delays' || type === 'crewtats')   return { xs: 'span 12', md: 'span 4' };
  return 'span 12'; // indicators, indexes, default
};

const SortableCard = ({ id, type, data, span }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 10 : 1,
  };

  const renderCardContent = () => {
    switch (type) {
      case "indicators":
        return <IndicatorsCard data={data} />;
      case "indexes":
        return <IndexesCard data={data} />;
      case "charts":
        return <ChartsCard data={data} />;
      case "delays":
        return <DelaysCard data={data} />;
      case "otpByPorts":
        return <OtpByPortsCard data={data} />;
      case "crewtats":
        return <CrewTATsCard data={data} />;
      default:
        return <Box>Blank Card</Box>;
    }
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      {...attributes}
      sx={{
        gridColumn: span,
        transition: "all 0.2s",
        ...(isDragging && { opacity: 0.7, transform: "scale(1.05)" }),
      }}
    >
      <Card sx={{ position: "relative", height: "100%" }}>
        <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, height: 48, cursor: "grab" }} {...listeners} />
        {renderCardContent()}
      </Card>
    </Box>
  );
};

export function DraggableCards({ cards }) {
  return (
    <Box display="grid" gridTemplateColumns="repeat(12, minmax(0, 1fr))" gap={2}>
      {cards.map((card) => (
        <SortableCard
          key={card.id}
          id={card.id}
          type={card.type}
          data={card.data}
          span={getCardSpan(card.type)}
        />
      ))}
    </Box>
  );
}
